import React, { useEffect, useState } from "react";

//*MUI
import {
  Box,
  Divider,
  TableCell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { dismissLoader, presentLoader } from "../../../Services/loader";

//*files
import cssClasses from "./PaymentStatus.module.css";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import { FetchAllUserFromServer } from "../../../Services/PaymentStatus";
import { getSelectedProjectByIds } from "../../../Services/Dashboard";
import { getAllProjects } from "../../../Services/AssignProject";

import PaymentStatusDetailsModal from "../../../Modals/PaymentStatusDetailsModal/PaymentStatusDetailsModal";
import EmptyListIcon from "../../../Assets/Images/Common/EmptyListLeads.svg";
import { useNavigate } from "react-router-dom";

import DropDown from "../../../Subcomponents/DropDown";
import MultiSelectDropDown from "../../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown";
import { groupBy } from "lodash";
import { useSelector } from "react-redux";
import { errorTost } from "../../../Services/Toast";

const teamLeadStatusOption = [
  "All",
  "Pending",
  "Partial",
  "complete",
  "SDR pending",
  "SDR complete",
  "OCR & GST pending",
  "OCR & GST complete",
];

const individualStatusOption = ["All", "Pending", "Partial", "complete"];

function PaymentStatus() {
  const navigate = useNavigate();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const url = window.location.search;

  const [openMorePaymentStatusDetails, setOpenMorePaymentStatusDetails] =
    useState(false);
  const handleMorePaymentStatusDetailsOpen = () =>
    setOpenMorePaymentStatusDetails(true);
  const handleMorePaymentStatusDetailsClose = () =>
    setOpenMorePaymentStatusDetails(false);
  const [ViewMorePaymentStatusData, setViewMorePaymentStatusData] = useState(
    []
  );
  const [drpDownProjectSelectedVal, setDrpDownProjectSelectedVal] = useState(
    []
  );
  const [drpDownStatusSelectedVal, setDrpDownStatusSelectedVal] = useState(
    url.includes("status")
      ? decodeURIComponent(url.split("?")[4].split("=")[1])
      : "All"
  );

  const [showRowsByStatus, setShowRowsByStatus] = useState(false);
  const [userData, setUserData] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [paymentStatusData, setPaymentStatusData] = useState([]);

  const [NoPaymentStatusFound, setNoPaymentStatusFound] = useState(null);

  const [selectedRowId, setSelectedRowId] = useState(0);

  const [projects, setProjects] = useState([]);

  const [viewDetailsPopup, setViewDetailsPopup] = useState("");

  const teamIds = JSON.parse(localStorage.getItem("teamIds"));

  async function UsersFromServer(pageNumber, merge, teamIds, id , projectIds) {
    presentLoader();
    try {
      const UsersResp = await FetchAllUserFromServer(
        url.split("?")[1].split("=")[1],
        url.split("?")[2].split("=")[1],
        url.split("?")[3].split("=")[1],
        loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
          ? teamIds
          : [loggedInUser?.userId],
        id,
        projectIds.length !== 0 ? projectIds.map((v) => {
          return v.id
        }) :
        projects.map((v) => {
          return v.id
        }) 
      );

      if (UsersResp) {
        const filterData = UsersResp?.filter(
          (el) =>
            el.leadId !== null &&
            el.leadId.userId !== null &&
            el?.unitId?.projectId !== null &&
            el.unitId !== null
        );
        setPaymentStatusData(filterData);
        filterDataByStatus(filterData);
        return filterData;
      }
    } catch (err) {
      console.error("FetchAllUserFromServer", err);
      dismissLoader();
      errorTost(err.message);
    }
  }

  const getStatusData = (el, statusType) => {
    const statusMap = {
      Pending: 0,
      Partial: 1,
      Complete: 2,
      "SDR Pending": 3,
      "SDR Complete": 4,
      "OCR & GST Pending": 5,
      "OCR & GST Complete": 6,
    };
    return el?.statusData[statusMap[statusType]]?.[statusType] || [];
  };

  const filterDataByStatus = (arr) => {
    let filterByStatus = [];

    if (arr && arr.length > 0) {
      filterByStatus =
        drpDownStatusSelectedVal !== "All"
          ? arr?.filter((el) => el.status)
          : arr;
    }
    // else {
    //   filterByStatus =
    //     drpDownStatusSelectedVal !== "All"
    //       ? paymentStatusData?.filter(
    //           (el) => el.status
    //         )
    //       : paymentStatusData;
    // }
    const groupedData = filterByStatus.reduce((acc, current) => {
      const { leadId, paidAmount, bookingAmt ,status, created_at, paidAmt, unitCost } = current;
      const userId = leadId?.userId?.userId;
      const salesPerson = leadId?.userId?.name;
      if (!acc[userId]) {
        acc[userId] = {
          userId,
          salesPerson,
          created_at,
          statusData: [],
        };
      }

      // if (loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) {
      //   acc[userId].statusData.push(
      //     { "SDR Pending": [] },
      //     { "SDR Complete": [] },
      //     { "OCR & GST Pending": [] },
      //     { "OCR & GST Complete": [] }
      //   );
      // }
    

      if (!acc[userId].statusData) {
        acc[userId].statusData = {};
      }

      if (paidAmount === 0) {
        if (
          drpDownStatusSelectedVal === "All" ||
          drpDownStatusSelectedVal.toLowerCase() === "pending"
        ) {
          acc[userId].statusData[0]?.Pending ? acc[userId].statusData[0]?.Pending.push(current) : acc[userId].statusData[0] = {Pending :[current]};
        }
      } else if (paidAmount > 0 && paidAmount < bookingAmt.total) {
        if (
          drpDownStatusSelectedVal === "All" ||
          drpDownStatusSelectedVal.toLowerCase() === "partial"
        ) {
          let index = drpDownStatusSelectedVal === "All" ? 1 : 0
          acc[userId].statusData[index]?.Partial ? acc[userId].statusData[index]?.Partial.push(current) : acc[userId].statusData[index] = {Partial :[current]};
        }
      } else if (paidAmount >= bookingAmt.total) {
        if (
          drpDownStatusSelectedVal === "All" ||
          drpDownStatusSelectedVal.toLowerCase() === "complete"
        ) {
          let index = drpDownStatusSelectedVal === "All" ? 2 : 0
          acc[userId].statusData[index]?.Complete ? acc[userId].statusData[index]?.Complete.push(current) : acc[userId].statusData[index] = {Complete :[current]};
        }

        if (loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) {
          if (
            (drpDownStatusSelectedVal === "All" ||
              drpDownStatusSelectedVal.toLowerCase() === "sdr pending") &&
            unitCost?.sdr &&
            paidAmt?.sdr < unitCost?.sdr
          ) {
            let index = drpDownStatusSelectedVal === "All" ? 3 : 0
            acc[userId].statusData[index]?.["SDR Pending"] ? acc[userId].statusData[index]?.["SDR Pending"].push(current) : acc[userId].statusData[index] = {"SDR Pending" :[current]};
          } else if (
            (drpDownStatusSelectedVal === "All" ||
              drpDownStatusSelectedVal.toLowerCase() === "sdr complete") &&
            unitCost?.sdr &&
            paidAmt?.sdr >= unitCost?.sdr
          ) {
            let index = drpDownStatusSelectedVal === "All" ? 4 : 0
            acc[userId].statusData[index]?.["SDR Complete"] ? acc[userId].statusData[index]?.["SDR Complete"].push(current) : acc[userId].statusData[index] = {"SDR Complete" :[current]};
          }
          if (
            (drpDownStatusSelectedVal === "All" ||
              drpDownStatusSelectedVal.toLowerCase() === "ocr & gst pending") &&
            unitCost?.bsp &&
            paidAmt?.ocr < 0.1 * unitCost?.bsp
          ) {
            let index = drpDownStatusSelectedVal === "All" ? 5 : 0
            acc[userId].statusData[index]?.["OCR & GST Pending"] ? acc[userId].statusData[index]?.["OCR & GST Pending"].push(current) : acc[userId].statusData[index] = {"OCR & GST Pending" :[current]}
          } else if (
            (drpDownStatusSelectedVal === "All" ||
              drpDownStatusSelectedVal.toLowerCase() ===
                "ocr & gst complete") &&
            unitCost?.bsp &&
            paidAmt?.ocr >= 0.1 * unitCost?.bsp
          ) {
            let index = drpDownStatusSelectedVal === "All" ? 6 : 0
            acc[userId].statusData[index]?.["OCR & GST Complete"] ? acc[userId].statusData[index]?.["OCR & GST Complete"].push(current) : acc[userId].statusData[index] = {"OCR & GST Complete" :[current]};
          }
        }
      }

      return acc;
    }, {});

    const outputArray = Object.values(groupedData);
    setUserData(outputArray);

    const sampleData = () =>
      outputArray?.map((el, index) => ({
        id: index,
        name: el?.salesPerson,
        status: "Pending",
        count: getStatusData(el, "Pending").length.toString(),
        date: getStatusData(el, "Pending").length
          ? sortArray(getStatusData(el, "Pending"))
          : "-",
        viewDetails: el,
      }));

    let payload = [];

    if (drpDownStatusSelectedVal !== "All") {
      const filterdData = sampleData();
      const status =
        drpDownStatusSelectedVal === "Pending"
          ? "Pending"
          : drpDownStatusSelectedVal === "Partial"
          ? "Partial"
          : drpDownStatusSelectedVal === "complete"
          ? "Complete"
          : drpDownStatusSelectedVal === "SDR pending"
          ? "SDR Pending"
          : drpDownStatusSelectedVal === "SDR complete"
          ? "SDR Complete"
          : drpDownStatusSelectedVal === "OCR & GST pending"
          ? "OCR & GST Pending"
          : "OCR & GST Complete";
      filterdData?.forEach((val) => {
        if (
          val?.viewDetails?.statusData
            ?.map((v) => {
              return v[status]?.length;
            })
            .filter((v) => v !== undefined)[0] !== 0
        ) {
          payload.push(val);
        }
      });
    } else {
      payload = sampleData();
    }
    setPaymentStatus(payload);

      setTimeout(() => {
        dismissLoader();
      }, 700);
  };

  useEffect(() => {
    let findProjectObj = [];
    presentLoader();
    const fetchProjects = async () => {
      const selectedProjectList = await getSelectedProjectByIds(
        loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
          ? teamIds
          : [loggedInUser?.userId]
      );
      const uniqProject = groupBy(
        selectedProjectList?.data,
        (v) => v?.projectId
      );
      const uniqSelectedProjectId = Object.keys(uniqProject)?.map((v) => {
        return v;
      });
      const arr = [];

      if (uniqSelectedProjectId?.length > 0) {
        const projectArr = await getAllProjects();
        projectArr.data.forEach((v) => {
          const index = uniqSelectedProjectId?.findIndex(
            (i) => i === v?.projectId
          );
          if (index !== -1) {
            arr.push({
              name: v?.projectName,
              id: v?.projectId,
            });
          }
        });

        if (
          url.split("?")[1].split("=")[1] !== "null" &&
          url.split("?")[1].split("=")[1] !== "All"
        ) {
          for (
            let i = 0;
            i < url.split("?")[1].split("=")[1].split(",").length;
            i++
          ) {
            let obj = [...arr].find(
              (el) =>
                el.name ===
                decodeURIComponent(
                  url.split("?")[1].split("=")[1].split(",")[i]
                )
            );
            findProjectObj.push(obj);
          }
          setDrpDownProjectSelectedVal(findProjectObj);
        }

        setProjects(arr);
      } else {
        setProjects([]);
      }
    //  dismissLoader();

      return { arr };
    };
    fetchProjects()
      .then((res) => {
        
        presentLoader();
        UsersFromServer(0, false, teamIds, findProjectObj , res.arr);

        filterDataByStatus(paymentStatusData);

        navigate(
          window.location.pathname +
            `?projectName=${
              url.split("?")[1].split("=")[1]
                ? url.split("?")[1].split("=")[1]
                : "null"
            }?startDate=${
              url.split("?")[2].split("=")[1] !== null
                ? url.split("?")[2].split("=")[1]
                : 0
            }?endDate=${
              url.split("?")[3].split("=")[1] !== null
                ? url.split("?")[3].split("=")[1]
                : 0
            }?status=${drpDownStatusSelectedVal}`
        );
       // dismissLoader();
      })
      .catch((e) => {
        dismissLoader();
      });
  }, []);

  useEffect(() => {
    if (
      drpDownProjectSelectedVal &&
      drpDownProjectSelectedVal.length > 0 &&
      drpDownProjectSelectedVal !== "All"
    ) {
      UsersFromServer(0, false, teamIds, drpDownProjectSelectedVal , projects).then(
        (val) => {
          filterDataByStatus(val);
        }
      );
    } else {
      UsersFromServer(0, false, teamIds , [] , projects).then((val) => {
        filterDataByStatus(val);
      });
    }

    //filterDataByStatus();
  }, [drpDownProjectSelectedVal]);

  useEffect(() => {
    filterDataByStatus(paymentStatusData);

    if (drpDownStatusSelectedVal && drpDownStatusSelectedVal !== "All") {
      setShowRowsByStatus(true);
    } else {
      setShowRowsByStatus(false);
    }

    navigate(
      window.location.pathname +
        `?projectName=${
          url.split("?")[1].split("=")[1]
            ? url.split("?")[1].split("=")[1]
            : "null"
        }?startDate=${
          url.split("?")[2].split("=")[1] !== null
            ? url.split("?")[2].split("=")[1]
            : 0
        }?endDate=${
          url.split("?")[3].split("=")[1] !== null
            ? url.split("?")[3].split("=")[1]
            : 0
        }?status=${drpDownStatusSelectedVal}`
    );
  }, [drpDownStatusSelectedVal]);

  const sortArray = (arr) => {
    const sorted = arr?.sort((a, b) => b?.created_at - a?.created_at);

    const timestamp = sorted?.[0]?.created_at;

    if (!timestamp) {
      return "-";
    }

    const currentDate = new Date();
    const date = new Date(timestamp);

    const isToday =
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getFullYear() === currentDate.getFullYear();

    if (isToday) {
      const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return "Today, " + new Intl.DateTimeFormat("en-US", options).format(date);
    } else {
      const options = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return new Intl.DateTimeFormat("en-US", options).format(date);
    }
  };

  return (
    <Box className={cssClasses.Container}>
      <Box mb={1}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>
              Allotment Payment Status
            </Box>
          </Box>
        </Box>
      </Box>

      <Divider />
      <Box margin={"1rem 0"}></Box>

      <div className={cssClasses.filtersDiv}>
        <div className={cssClasses.filtersDivA}>
          <div className={cssClasses.dropdownFilter}>
            <div style={{ fontSize: "14px", marginBottom: "0.5rem" }}>
              Projects :{" "}
            </div>
            <MultiSelectDropDown
              list={projects}
              value={drpDownProjectSelectedVal}
              flag={true}
              handleChange={(e) => {
                const value = e?.target?.value;

                if (value !== "") {
                  if (value[value.length - 1] === "all") {
                    setDrpDownProjectSelectedVal(
                      drpDownProjectSelectedVal.length === projects.length
                        ? []
                        : projects
                    );
                    navigate(
                      window.location.pathname +
                        `?projectName=${projects.map((el) => el.name)}?startDate=${
                          url.split("?")[2].split("=")[1] !== null
                            ? url.split("?")[2].split("=")[1]
                            : 0
                        }?endDate=${
                          url.split("?")[3].split("=")[1] !== null
                            ? url.split("?")[3].split("=")[1]
                            : 0
                        }?status=${drpDownStatusSelectedVal}`
                    );
                    return;
                  }

                  setDrpDownProjectSelectedVal(value);
                  navigate(
                    window.location.pathname +
                      `?projectName=${value.map((el) => el.name)}?startDate=${
                        url.split("?")[2].split("=")[1] !== null
                          ? url.split("?")[2].split("=")[1]
                          : 0
                      }?endDate=${
                        url.split("?")[3].split("=")[1] !== null
                          ? url.split("?")[3].split("=")[1]
                          : 0
                      }?status=${drpDownStatusSelectedVal}`
                  );
                  setDrpDownStatusSelectedVal(
                    decodeURIComponent(url.split("?")[4].split("=")[1])
                  );
                }
              }}
              placeHolder={"Search Project"}
              style={{
                background: "#F2F4F7",
                color: "rgb(102, 112, 133)",
                minWidth: "250px",
                borderRadius: "4rem",
                width: "350px",
              }}
              helperText={""}
            />
          </div>
          <div className={cssClasses.dropdownFilter}>
            <div style={{ fontSize: "14px" }}>Status : </div>
            <DropDown
              list={
                loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
                  ? teamLeadStatusOption
                  : individualStatusOption
              }
              selectedValue={drpDownStatusSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownStatusSelectedVal(_value);
              }}
              placeHolder={"Select Status"}
              style={{
                background: "#F2F4F7",
                color: "rgb(102, 112, 133)",
                minWidth: "250px",
                borderRadius: "4rem",
                padding: "1rem 1rem",
              }}
              helperText={""}
            />
          </div>
        </div>
      </div>

      <React.Fragment>
        <Box sx={{ margin: 1, width: "96%", overflowX: "scroll" }}>
          <Table
            size="large"
            aria-label="purchases"
            className={cssClasses.tableBorder}
          >
            <TableHead className={cssClasses.tableHead}>
              <TableRow className={cssClasses.tableRow1}>
                <TableCell className={cssClasses.innerTitle}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "95%",
                      marginLeft: "0.3rem",
                    }}
                  >
                    <div style={{ width: "300px" }}>Sales Person </div>
                    <div style={{ width: "300px" }}>Status </div>
                    <div style={{ width: "200px" }}>Count </div>
                    <div style={{ width: "200px" }}>View </div>
                    <div style={{ width: "300px" }}>Date </div>
                    <div style={{ width: "10px" }}>{""}</div>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <div
              className={
                paymentStatus.length > 0
                  ? cssClasses.tableBodyDiv
                  : cssClasses.tableBodyDivNoData
              }
            >
              {" "}
              <TableBody
                sx={{
                  maxHeight: "200px",
                  overflowX: paymentStatus.length > 0 ? "scroll" : "",
                }}
              >
                {paymentStatus.length > 0 ? (
                  paymentStatus.map((elm, index) => (
                    <TableRow key={index}>
                      {drpDownStatusSelectedVal === "All" ? <Accordion
                        sx={{
                          "& .MuiPaper-root": {
                            color: "darkslategray",
                            backgroundColor: "#E4FAF4",
                            borderRadius: "0.6rem",
                            boxShadow: "none",
                          },

                          boxShadow: "none",
                          borderBottom: "3px solid #EAECF0",
                        }}
                        expanded={selectedRowId === elm.id}
                      >
                        <AccordionSummary
                          expandIcon={
                            selectedRowId === elm.id ? (
                              <RemoveCircleOutlineIcon
                                sx={{
                                  color: "#1570EF",
                                  height: "20px",
                                  width: "20px",
                                }}
                                onClick={() => setSelectedRowId(-1)}
                              />
                            ) : (
                              <AddCircleOutlineIcon
                                sx={{
                                  color: "#1570EF",
                                  height: "20px",
                                  width: "20px",
                                }}
                                onClick={() => setSelectedRowId(elm.id)}
                              />
                            )
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              marginLeft: "0.3rem",
                            }}
                          >
                            <div
                              className={cssClasses.FirstTitle}
                              style={{ width: "300px" }}
                            >
                              {elm?.name || "-"}
                            </div>
                            <div
                              className={cssClasses.innerTitle}
                              style={{ width: "300px" }}
                            >
                              {elm?.status || "-"}
                            </div>
                            <div
                              className={cssClasses.innerTitle}
                              style={{ width: "200px" }}
                            >
                              {elm?.count || "-"}
                            </div>
                            <div
                              className={cssClasses.innerTitle}
                              style={{
                                width: "200px",
                              }}
                            >
                              {elm?.count === 0 || elm?.count === "0" ? (
                                <p>-</p>
                              ) : (
                                <p
                                  style={{
                                    cursor: "pointer",
                                    textDecorationLine: "underline",
                                  }}
                                  onClick={() => {
                                    setViewMorePaymentStatusData(
                                      elm.viewDetails
                                    );
                                    handleMorePaymentStatusDetailsOpen();
                                    setViewDetailsPopup(elm?.status);
                                  }}
                                >
                                  View Details
                                </p>
                              )}
                            </div>
                            <div
                              className={cssClasses.innerTitle}
                              style={{ width: "370px" }}
                            >
                              {elm?.date || ""}
                            </div>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: "0 !important" }}>
                          {userData[0]?.statusData && (
                            <>
                              {(selectedRowId === -1 &&
                              !selectedRowId &&
                              selectedRowId >= 0
                                ? userData[0]?.statusData
                                : userData[selectedRowId]?.statusData
                              )?.map((el, i) => {
                                const id =
                                  selectedRowId === -1 ? 0 : selectedRowId;
                                const statusType = Object.keys(
                                  userData[id]?.statusData[i]
                                );
                                const newVar = statusType[0];

                                return showRowsByStatus &&
                                  userData[id]?.statusData?.[i]?.[`${newVar}`]
                                    ?.length === 0 ? (
                                  <div></div>
                                ) : (
                                  newVar !== "Pending" && (
                                    <div key={i}>
                                      <Divider />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                          margin: "2rem 0rem",
                                          marginLeft: "2rem",
                                        }}
                                      >
                                        <div
                                          className={cssClasses.FirstTitle}
                                          style={{ width: "300px" }}
                                        ></div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "300px" }}
                                        >
                                          {statusType}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        >
                                          {userData[id]?.statusData?.[i]?.[
                                            `${newVar}`
                                          ]?.length
                                            ? userData[id]?.statusData?.[i]?.[
                                                `${newVar}`
                                              ]?.length
                                            : 0}
                                        </div>

                                        {userData[id]?.statusData?.[i]?.[
                                          `${newVar}`
                                        ]?.length === 0 ||
                                        !userData[id]?.statusData?.[i]?.[
                                          `${newVar}`
                                        ] ? (
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{
                                              width: "200px",
                                            }}
                                          >
                                            -
                                          </div>
                                        ) : (
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{
                                              cursor: "pointer",
                                              textDecorationLine: "underline",
                                              width: "200px",
                                            }}
                                            onClick={() => {
                                              setViewMorePaymentStatusData(
                                                elm.viewDetails
                                              );
                                              handleMorePaymentStatusDetailsOpen();
                                              setViewDetailsPopup(
                                                statusType[0]
                                              );
                                            }}
                                          >
                                            View Details
                                          </div>
                                        )}

                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "280px" }}
                                        >
                                          {sortArray(
                                            userData[id]?.statusData?.[i]?.[
                                              `${newVar}`
                                            ]
                                          )}
                                        </div>
                                      </Box>
                                    </div>
                                  )
                                );
                              })}
                            </>
                          )}
                        </AccordionDetails>
                      </Accordion> :  <>{userData[0]?.statusData && (
                            <>
                              {(selectedRowId === -1 &&
                              !selectedRowId &&
                              selectedRowId >= 0
                                ? userData[0]?.statusData
                                : userData[selectedRowId]?.statusData
                              )?.map((el, i) => {
                                const id = index;
                                const status =
                                  drpDownStatusSelectedVal === "Pending"
                                    ? "Pending"
                                    : drpDownStatusSelectedVal === "Partial"
                                    ? "Partial"
                                    : drpDownStatusSelectedVal === "complete"
                                    ? "Complete"
                                    : drpDownStatusSelectedVal === "SDR pending"
                                    ? "SDR Pending"
                                    : drpDownStatusSelectedVal ===
                                      "SDR complete"
                                    ? "SDR Complete"
                                    : drpDownStatusSelectedVal ===
                                      "OCR & GST pending"
                                    ? "OCR & GST Pending"
                                    : "OCR & GST Complete";
                                const statusType = [status]
                                const newVar = statusType[0];
                                return showRowsByStatus &&
                                  userData?.[id]?.statusData?.[i]?.[`${newVar}`]
                                    ?.length === 0 ? (
                                  <div></div>
                                ) : ((
                                    <div key={i}>
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                          margin: "2rem 0rem",
                                          marginLeft: "2rem",
                                        }}
                                      >
                                        <div
                                          className={cssClasses.FirstTitle}
                                          style={{ width: "300px" }}
                                        >{userData[id]?.salesPerson}</div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "300px" }}
                                        >
                                          {statusType}
                                        </div>
                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "200px" }}
                                        >
                                          {userData[id]?.statusData?.[i]?.[
                                            `${newVar}`
                                          ]?.length
                                            ? userData[id]?.statusData?.[i]?.[
                                                `${newVar}`
                                              ]?.length
                                            : 0}
                                        </div>

                                        {userData[id]?.statusData?.[i]?.[
                                          `${newVar}`
                                        ]?.length === 0 ||
                                        !userData[id]?.statusData?.[i]?.[
                                          `${newVar}`
                                        ] ? (
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{
                                              width: "200px",
                                            }}
                                          >
                                            -
                                          </div>
                                        ) : (
                                          <div
                                            className={cssClasses.innerTitle}
                                            style={{
                                              cursor: "pointer",
                                              textDecorationLine: "underline",
                                              width: "200px",
                                            }}
                                            onClick={() => {
                                              setViewMorePaymentStatusData(
                                                elm.viewDetails
                                              );
                                              handleMorePaymentStatusDetailsOpen();
                                              setViewDetailsPopup(
                                                statusType[0]
                                              );
                                            }}
                                          >
                                            View Details
                                          </div>
                                        )}

                                        <div
                                          className={cssClasses.innerTitle}
                                          style={{ width: "280px" }}
                                        >
                                          {sortArray(
                                            userData[id]?.statusData?.[i]?.[
                                              `${newVar}`
                                            ]
                                          )}
                                        </div>
                                      </Box>
                                    </div>
                                  )
                                );
                              })}
                            </>
                          )}</>}
                    </TableRow>
                  ))
                ) : (
                  <div className={cssClasses.noDataWrapper}>
                    <div className={cssClasses.noDataMsg}>
                      <div className={cssClasses.emptyIcon}>
                        <img src={EmptyListIcon} alt="No Requests" />
                      </div>
                      <div className={cssClasses.emptyTitle}>
                        No Allotment payment status to show!
                      </div>
                    </div>
                  </div>
                )}
              </TableBody>
            </div>
          </Table>
        </Box>
      </React.Fragment>

      {openMorePaymentStatusDetails && (
        <PaymentStatusDetailsModal
          open={openMorePaymentStatusDetails}
          handleClose={handleMorePaymentStatusDetailsClose}
          data={ViewMorePaymentStatusData}
          popupType={viewDetailsPopup}
        />
      )}

      {NoPaymentStatusFound === false && (
        <Box>
          <Box className={cssClasses.noDataMsg}>
            <Box className={cssClasses.emptyIcon}>
              <img src={EmptyState} alt="No Wings" />
            </Box>
            <Box className={cssClasses.emptyTitle}>No paymentStatus found</Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default PaymentStatus;
